/** Mail type = which placeholder catalog the template uses (API `type` field). */
export type MailTemplateType = "service" | "training";

export const MAIL_TEMPLATE_TYPES = ["service", "training"] as ReadonlyArray<MailTemplateType>;

export const MAIL_TEMPLATE_TYPE_LABELS: Record<MailTemplateType, string> = {
  service: "Service",
  training: "Formation",
};

export const MAIL_TEMPLATE_TYPE_OPTIONS: { value: MailTemplateType; label: string }[] =
  MAIL_TEMPLATE_TYPES.map((t) => ({ value: t, label: MAIL_TEMPLATE_TYPE_LABELS[t] }));

/** Training lifecycle events a training template can bind a `training` mail to. */
export type TrainingMailEvent =
  | "trainingStart"
  | "trainingAdded"
  | "trainingInProgress"
  | "trainingEnd";

export const TRAINING_MAIL_EVENT_LABELS: Record<TrainingMailEvent, string> = {
  trainingStart: "Début de formation",
  trainingAdded: "Ajout de formation",
  trainingInProgress: "Accès à la formation",
  trainingEnd: "Fin de formation",
};

export interface MailTemplate {
  id?: number;
  company_id?: number;
  name: string;
  type: MailTemplateType;
  subject: string;
  /** Body HTML fragment only; header/footer are applied by the API when sending. */
  html: string;
  to: string[];
  bcc?: string[];
  created_at?: string;
  updated_at?: string;
}

/** GET/PUT /communication-settings — invitation mail binding (Users module). */
export interface CommunicationSettings {
  welcome_user_mail_template_id: number;
}

/** API: `standard` = To/Bcc (e-mail) chips only; `body_fragment` = body, subject strings, IF/else booleans. */
export const MAIL_PLACEHOLDER_CATEGORY_STANDARD = "standard" as const;
export const MAIL_PLACEHOLDER_CATEGORY_BODY_FRAGMENT = "body_fragment" as const;

export type MailPlaceholderCategory =
  | typeof MAIL_PLACEHOLDER_CATEGORY_STANDARD
  | typeof MAIL_PLACEHOLDER_CATEGORY_BODY_FRAGMENT;

/** API JSON field `type` — semantic value shape (matches Go mailkit PlaceholderType*). */
export const MAIL_PLACEHOLDER_TYPE_EMAIL = "email" as const;
export const MAIL_PLACEHOLDER_TYPE_PHONE = "phone" as const;
export const MAIL_PLACEHOLDER_TYPE_URL = "url" as const;
export const MAIL_PLACEHOLDER_TYPE_BOOLEAN = "boolean" as const;
export const MAIL_PLACEHOLDER_TYPE_STRING = "string" as const;

export type MailPlaceholderValueType =
  | typeof MAIL_PLACEHOLDER_TYPE_EMAIL
  | typeof MAIL_PLACEHOLDER_TYPE_PHONE
  | typeof MAIL_PLACEHOLDER_TYPE_URL
  | typeof MAIL_PLACEHOLDER_TYPE_BOOLEAN
  | typeof MAIL_PLACEHOLDER_TYPE_STRING;

/** Placeholder catalog from GET /mail-templates/placeholders?type=… (one catalog per mail type). */
export interface MailPlaceholderDefinition {
  key: string;
  /** Short editor title (French). */
  label?: string;
  description: string;
  example?: string;
  /** Semantic type: `boolean` = {{if .Key}} in structured editors; email/url/string for hints. */
  type: MailPlaceholderValueType;
  /** Where the UI may offer this placeholder (see constants). */
  category: MailPlaceholderCategory;
}
